import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import type {
  SidebarCardId,
  SidebarSectionId,
} from 'components/conversation/components/sidebar/conversationSidebar.types';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { useCardSectionVisibility } from '../../hooks/useCardSectionVisibility';
import { useSidebarMode } from '../../hooks/useSidebarMode';

type VisibilityToggleProps = {
  itemId: SidebarCardId | SidebarSectionId;
  itemType: 'section' | 'card';
};

export const VisibilityToggle = ({
  itemId,
  itemType,
}: VisibilityToggleProps): JSX.Element | null => {
  const { hiddenItems, toggleItemVisibility } = useCardSectionVisibility();
  const flags = useFeatureFlag(['conversation-right-sidebar-visibility']);

  if (useSidebarMode() !== 'customization') {
    return null;
  }

  const isHidden = hiddenItems.has(itemId);

  return flags.conversationRightSidebarVisibility ? (
    <Tooltip content={isHidden ? `Show ${itemType}` : `Hide ${itemType}`}>
      <IconButton
        icon={isHidden ? 'eye-slash' : 'eye'}
        variant="tertiary"
        onClick={(event) => {
          event.stopPropagation();
          toggleItemVisibility(itemId);

          ampli.conversationRightSidebarItemVisibilityToggled({
            isVisible: isHidden,
            sidebarItemType: itemType,
          });
        }}
      />
    </Tooltip>
  ) : null;
};
